export default "__VITE_ASSET__BV36IuOL__";